import logo from '../assets/dglogo.svg'

export default function Logo() {
    return(
        <img className='navbar-logo' src={logo} alt="" srcset="" />
    )
}